import { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import { t } from 'ttag';
import { useLoading } from '../LoadingContext';
import Services from '../eventpage/services';

const TimeoutPage = () => {
  const { eventId } = useParams();
  const header = document.getElementById('headerLogo');
  const { toggleLoading } = useLoading();
  const CONSTANTS = {
    fizetesiModAzonositok: ['BAR'],
    FIZMOD_KOD_BARION: 'BAR'
  };
  const [themeReady, setThemeReady] = useState([]);

  useEffect(() => {
      if (themeReady) {
          const timer = setTimeout(() => {
              toggleLoading(false);
          }, 1000); // 1000ms = 1 second

          return () => clearTimeout(timer); // cleanup
      }
  }, [themeReady]);

  const loadData = () => {

    //const eventId = localStorage.getItem("redirecturl");

    Services.getEvent(eventId, CONSTANTS.fizetesiModAzonositok, (err, res) => {
      if (!err) {
          Services.getSzin(res[0].layout.vid, (errEvent, resEvent) => {
            if (!errEvent) {

              if (isEmptyObject(resEvent[0])) {
                setThemeReady(true);
                //console.log("e",resEvent[0])
              } else {

                //console.log(resEvent[0].color[0])

                if (resEvent[0].color[0] === 'VILAGOS') {
                  //body.classList.remove('dark-theme');
                  document.documentElement.style.setProperty("--svg-viewer-hatter-szin", "#fff");
                  document.documentElement.style.setProperty("--base-font-szin", "#000")

                  // same


                  document.documentElement.style.setProperty("--elsodleges-szin", "#" + resEvent[0].color[1]);
                  document.documentElement.style.setProperty("--footer-hatter", "#" + resEvent[0].color[4]);
                  document.documentElement.style.setProperty("--input-border-focus-szin", "#" + resEvent[0].color[2])
                  document.documentElement.style.setProperty("--form-control-focus-szin", hexToRgb(resEvent[0].color[2],80));




                  document.documentElement.style.setProperty("--navbar-background", hexToRgb(resEvent[0].color[3],80));
                } else {
                  document.body.classList.add('dark-theme');

                  document.body.style.setProperty("--base-font-szin", "#fff");
                  document.body.style.setProperty("--elsodleges-szin", "#" + resEvent[0].color[1]);
                  document.body.style.setProperty("--footer-hatter", "#" + resEvent[0].color[4]);
                  document.body.style.setProperty("--input-border-focus-szin", "#" + resEvent[0].color[2])
                  document.body.style.setProperty("--form-control-focus-szin", hexToRgb(resEvent[0].color[2],80));

                  document.body.style.setProperty("--navbar-background", hexToRgb(resEvent[0].color[3],80));
                }

                const base64Logo = "data:image/png;base64," + resEvent[0].logo[0];

                document.getElementById("headerLogo").src = base64Logo;
                document.getElementById("navbar-brand").href = res[0].layout.vws ? res[0].layout.vws : "";

                const footer = document.getElementById('sticky-footer');
                const contrast = getContrastYIQ(resEvent[0].color[4])

                document.body.style.setProperty("--visszaszamlalo-szin", getCorrectTextColor(resEvent[0].color[1]))

                if (getContrastYIQ(resEvent[0].color[4]) === 'darkf') {
                  document.body.style.setProperty("--footer-link-color", "#3c3c3c");
                } else {
                  document.body.style.setProperty("--footer-link-color", "#dcdcdc");
                }

                footer.classList.remove("darkf-bg", "lightf-bg");
                footer.classList.add(contrast + '-bg');

                setThemeReady(true);

              }

            } else {
                setThemeReady(true);
            }
          });
      }
    });
  }

  useEffect(() => {
    loadData();
  }, []);

  /*
  useEffect(() => {
    document.body.classList.add("dark-theme");
    
    if(header && header.classList) {header.classList.add("feher-logo")}
    
    //toggleLoading(false);

    // Cleanup (opcionális, ha eltávolítanád a class-t amikor a komponens unmountolódik)
    return () => {
      document.body.classList.remove("dark-theme");
    };
  }, []);
  */
  
  const hexToRgb = (hex, opacity) => {
    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);

    return 'rgba(' + r + ',' + g + ',' + b + ',' + opacity / 100 + ')';
  };

  const getCorrectTextColor = (hex) => {
    /*
    From this W3C document: http://www.webmasterworld.com/r.cgi?f=88&d=9769&url=http://www.w3.org/TR/AERT#color-contrast

    Color brightness is determined by the following formula:
    ((Red value X 299) + (Green value X 587) + (Blue value X 114)) / 1000

    I know this could be more compact, but I think this is easier to read/explain.

    */

    let threshold = 130; /* about half of 256. Lower threshold equals more dark text on dark background  */

    function cutHex(h) { return (h.charAt(0) === '#') ? h.substring(1, 7) : h; }
    function hexToR(h) { return parseInt((cutHex(h)).substring(0, 2), 16); }
    function hexToG(h) { return parseInt((cutHex(h)).substring(2, 4), 16); }
    function hexToB(h) { return parseInt((cutHex(h)).substring(4, 6), 16); }

    let hRed = hexToR(hex);
    let hGreen = hexToG(hex);
    let hBlue = hexToB(hex);

    let cBrightness = ((hRed * 299) + (hGreen * 587) + (hBlue * 114)) / 1000;
    if (cBrightness > threshold) { return '#000000'; } return '#ffffff';
  };

  const isEmptyObject = (obj) => {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
  }
  
  const getContrastYIQ = (hexcolor) => {
    hexcolor = hexcolor.replace('#', '');
    var r = parseInt(hexcolor.substr(0, 2), 16);
    var g = parseInt(hexcolor.substr(2, 2), 16);
    var b = parseInt(hexcolor.substr(4, 2), 16);
    var yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
    return (yiq >= 128) ? 'darkf' : 'lightf';
  }

  const handleBackClick = () => {
    //const redirectUrl = localStorage.getItem("redirecturl");
    window.location.replace(`${process.env.PUBLIC_URL}/event/${eventId}`);
  };

  return (
    <div className="landing__section">
      <div className="row" style={{ padding: 20 }}>
        <div className="wrapper col-md-8" style={{ padding: 20 }}>
          <p style={{ fontSize: '1.75rem', textAlign: 'center' }}>
            {t`A rendelkezésre álló idő lejárt, a jegyek fel lettek szabadítva!`}
          </p>
          <p style={{ fontSize: '1.1rem', textAlign: 'center' }}>
            {t`Annak érdekében, hogy a jegyek a lehető legtöbb ember számára hozzáférhetők legyenek, minden rendelés jobb felső sarkában egy időzítőt helyezünk el a fizetési folyamat során. Ha nem fejezi be a rendelést a  megadott határidőn belül, a jegyek mások számára felszabadításra kerülnek.`}
          </p>
          <p style={{ fontSize: '1.1rem', textAlign: 'center' }}>
            {t`Kérjük kezdd elölről a rendelésed!`}
          </p>
          <button
            type="button"
            className="search-button-style btn btn-secondary float-right text-correct-button"
            onClick={handleBackClick}
          >
            {t`Vissza`}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TimeoutPage;
